<template>
    <div>
        <button
            @click="onClick"
            :class="buttonClass"
        >
            <slot/>
        </button>
        <span v-if="errorMessage">{{ errorMessage }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            buttonClass: String,
            siteName: String,
            currency: String,
            isAnnual: {
                type: Boolean,
                default: false,
            },
            isTrial: {
                type: Boolean,
                default: false,
            },
            url: String,
            couponCode: String,
        },

        data() {
            return {
                cbInstance: null,
                errorMessage: null,
                successUrl: null,
            };
        },

        mounted: function () {
            this.cbInstance = window.Chargebee.init({site: this.siteName});
        },

        methods: {
            onClick() {
                this.cbInstance.openCheckout({
                    hostedPage: () => {
                        // Hit your end point that returns hosted page object as response
                        // This sample end point will call the below api
                        // You can pass hosted page object created as a result of checkout_new, checkout_existing, manage_payment_sources
                        // https://apidocs.chargebee.com/docs/api/hosted_pages#checkout_new_subscription
                        // https://apidocs.chargebee.com/docs/api/hosted_pages#checkout_existing_subscription
                        // https://apidocs.chargebee.com/docs/api/hosted_pages#manage_payment_sources
                        // If you want to use paypal, go cardless and plaid, pass embed parameter as false
                        return axios.post(this.url || '/payments/chargebee/subscribe-url', {
                                currency: this.currency,
                                isAnnual: this.isAnnual,
                                isTrial: this.isTrial,
                                couponCode: this.couponCode || null,
                            }).then(response => {
                                this.successUrl = response.data.success_url;
                                return response.data;
                            });
                    },
                    success: (hostedPageId) => {
                        return axios.post(this.successUrl, {hostedPageId})
                            .then(response => {
                                if (response.data.redirect_url) {
                                    window.location.href = response.data.redirect_url
                                }
                            })
                    },
                    error: (error) => {
                        this.errorMessage = (error.response && error.response.data.message) || error.toString();
                    },
                });
            },
        },
    };
</script>
